module.exports = __webpack_public_path__ + "static/media/img_3.7eb13785.JPG";